import styled from "styled-components";

export const StyledInput = styled.div`
  display: flex;
  align-items: center;
  color: var(--allie-color-primary-70);
`;
